import { list } from './list';

export type { AuditLogListQuery } from './list';

export const auditLogs = {
  list,
};
